import React from 'react';
import styles from './TestimonialsSection.module.scss';
import { useTranslation } from 'react-i18next';
import endpoints from '../../../../api/endpoints';
import { useGetQuery } from '../../../../services/apiCall';
import Carousel from '../../../molecule/carousel/Carousel';
import Slide from './testimonialCarousel/slideOne/Slide';
import Text from '../../../atoms/text/Text';
import { useMediaQuery } from 'react-responsive';
import useIsRtl from '../../../../app/helpers/isRtl';
import getCookie from '../../../../app/helpers/getCookie';

const SECTION_ID = 8;

const TestimonialsSection = ({ currentSection }) => {
  const isEnglish = getCookie('googtrans')?.includes('/ar/en');

  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const isRtl = useIsRtl();
  const apiUrl = endpoints.testimonials.get;
  const isMobile = useMediaQuery({ maxWidth: 800 });
  const isTablet = useMediaQuery({ minWidth: 801, maxWidth: 1299 });
  const isDesktop = useMediaQuery({ minWidth: 1300 });
  const itemsPerSlide = isDesktop ? 3 : isTablet ? 2 : isMobile ? 1 : 1;

  const loadSlider =
    currentSection >= SECTION_ID - 1 && currentSection <= SECTION_ID + 1;

  const { data, error, isLoading, refetch } = useGetQuery({
    apiUrl: apiUrl,
    params: ['HomePage'],
  });
  const chunkedTestimonials = data
    ? data.reduce((acc, item, idx) => {
        const chunkIndex = Math.floor(idx / itemsPerSlide);
        if (!acc[chunkIndex]) acc[chunkIndex] = [];
        acc[chunkIndex].push(item);
        return acc;
      }, [])
    : [];

  const CarouselData = chunkedTestimonials.map((group, idx) => (
    <Slide key={idx} testimonials={group} language={currentLanguage} />
  ));
  return (
    <div
      className={styles['testimonial-container']}
      style={{ direction: isRtl ? 'rtl' : 'ltr' }}
    >
      <Text
        title={isEnglish ? 'Testimonial' : 'home.testimonial'}
        variant="text-bold-italic-40"
        className={styles['title']}
      />
      <Carousel
        components={CarouselData}
        dots={styles['desktop-dots']}
        // swipeAction={swipeAction}
        hideArrowsOnMobile
        // getSlide={getSlide}
        style={{ direction: isRtl ? 'ltr' : 'ltr' }}
      />
    </div>
  );
};

export default TestimonialsSection;
